import { useEffect, useState } from 'react';
import { getShopifyProductList } from 'lowcode/apis/getShopifyProductList';
import ProductNav from '../../../common/ProductNav';
import { learnMoreLink, productType, variantId, shopNowLink } from '../../../config/pageConfig';
import BannerAnimation from '../components/BannerAnimation';
import Covered from '../components/Covered';
import D3Serues from '../components/D3Serues';
import Certificate from '../components/Certificate';
import BlogNews from '../components/BlogNews';
import FooterTcA from '../components/FooterTcA';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';

export default function StatusItem() {
    const { t } = useLang();
    const { locale } = getLocal();
    const shopNow = shopNowLink[locale] || shopNowLink.us;
    const variantList = variantId[locale] || variantId.us;

    const [d3sList, setD3sList] = useState([
        {
            id: productType.D3U,
            title: t('D3US.D3US_title'),
            desc: t('D3US.D3US_desc'),
            imglist: [
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758779385254-yccm95-compressed-Frame%202094654419.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758712447530-2ike4s-compressed-Frame%201000008514.jpg',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876809995-b4zcww-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1759029182782-471b68-compressed-Frame%201000009345.jpg',
                    title: t('D3US.D3US_selling1_text'),
                    desc: t('D3US.D3US_selling1_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876858380-5t9eey-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761211472582-cswan1-compressed-Frame%202094654422.jpg',
                    title: t('D3US.D3US_selling2_text'),
                    desc: t('D3US.D3US_selling2_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876886970-9d3pd8-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1759029234209-o4ltnz-compressed-Frame%201000009345.jpg',
                    title: t('D3US.D3US_selling3_text'),
                    desc: t('D3US.D3US_selling3_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876900134-l8bqn7-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1759029247096-2zuu1y-compressed-Frame%201000009346.jpg',
                    title: t.rich('D3US.D3US_selling4_text', {
                        sup: (text: string) => <sup>{text}</sup>,
                    }),
                    desc: t('D3US.D3US_selling4_desc'),
                },
            ],
            productlist: [
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758203904709-cd5itb-compressed-D3UP%E5%8F%B3%E4%BE%A7-%E7%BE%8E%E8%A7%84%201.png',
                    title: t('D3US.D3US_product1_name'),
                    desc: t('D3US.D3US_product1_desc'),
                    learnmore: learnMoreLink.d3u,
                    buylink: shopNow.d3up,
                    variantId: variantList.d3up,
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758203929432-91qcug-compressed-D3U%E5%8F%B3%E4%BE%A7-%E7%BE%8E%E8%A7%84%201.png',
                    title: t('D3US.D3US_product2_name'),
                    desc: t('D3US.D3US_product2_desc'),
                    learnmore: learnMoreLink.d3u,
                    buylink: shopNow.d3u,
                    variantId: variantList.d3u,
                },
            ],
        },
        {
            id: productType.D3M,
            title: t('D3MS.D3MS_title'),
            desc: t('D3MS.D3MS_desc'),
            imglist: [
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758779409650-ediwrl-compressed-Frame%202094654420.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758712593914-ba9v4g-compressed-Frame%201000008514.jpg',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876923061-wawke8-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758877178057-woi4x7-compressed-Frame%201000009345.jpg',
                    title: t('D3MS.D3MS_selling1_text'),
                    desc: t('D3MS.D3MS_selling1_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876939674-ob0ewc-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758877194788-mmbirn-compressed-Frame%201000009346.jpg',
                    title: t.rich('D3MS.D3MS_selling2_text', {
                        sup: (text: string) => <sup>{text}</sup>,
                    }),
                    desc: t('D3MS.D3MS_selling2_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1761211348692-e5853y-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761211511994-gtisju-compressed-Frame%202094654423.jpg',
                    title: t.rich('D3MS.D3MS_selling3_text', {
                        sup: (text: string) => <sup>{text}</sup>,
                    }),
                    desc: t('D3MS.D3MS_selling3_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1761211433291-0z70su-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1759029268972-a2p6me-compressed-Frame%201000009346.jpg',
                    title: t('D3MS.D3MS_selling4_text'),
                    desc: t('D3MS.D3MS_selling4_desc'),
                },
            ],
            productlist: [
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758203947588-sksj9t-compressed-D3MP%E5%8F%B3%E4%BE%A7-%E6%97%A5%E8%A7%84%202.png',
                    title: t('D3MS.D3MS_product1_name'),
                    desc: t('D3MS.D3MS_product1_desc'),
                    learnmore: learnMoreLink.d3m,
                    buylink: shopNow.d3mp,
                    variantId: variantList.d3mp,
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758203957481-nhnt1j-compressed-D3M%E6%8B%BC%E8%89%B2%E5%8F%B3%E4%BE%A7%E4%BF%AF-%E7%BE%8E%E6%97%A5%E8%A7%84%201.png',
                    title: t('D3MS.D3MS_product2_name'),
                    desc: t('D3MS.D3MS_product2_desc'),
                    learnmore: learnMoreLink.d3m,
                    buylink: shopNow.d3m,
                    variantId: variantList.d3m,
                },
            ],
        },
        {
            id: productType.D3C,
            title: t('D3C.D3C_title'),
            desc: t('D3C.D3C_desc'),
            imglist: [
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758779427089-4jqrbb-compressed-Frame%202094654421.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758712687782-ped4ac-compressed-Frame%201000008514.jpg',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876976761-xjq259-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758877234270-cxchit-compressed-Frame%201000009345.jpg',
                    title: t('D3C.D3C_selling1_text'),
                    desc: t('D3C.D3C_selling1_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758876992588-dkltml-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761211554875-xomzjg-compressed-Frame%202094654424.jpg',
                    title: t('D3C.D3C_selling2_text'),
                    desc: t('D3C.D3C_selling2_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758877003282-ijmc2l-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758877259799-ktlmx3-compressed-Frame%201000009345.jpg',
                    title: t('D3C.D3C_selling3_text'),
                    desc: t('D3C.D3C_selling3_desc'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758877014619-k6s0sm-compressed-image.jpg',
                    imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758877271958-3ozufj-compressed-Frame%201000009346.jpg',
                    title: t('D3C.D3C_selling4_text'),
                    desc: t('D3C.D3C_selling4_desc'),
                },
            ],
            productlist: [
                {
                    img: 'https://websiteoss.ecoflow.com/figma-uploads/1758203967920-d5kb8w-compressed-D3C%E6%B5%85%E7%81%B0%E5%8F%B3%E4%BE%A7-%E7%BE%8E%E8%A7%84%201.png',
                    title: t('D3C.D3C_product1_name'),
                    desc: t('D3C.D3C_product1_desc'),
                    learnmore: learnMoreLink.d3c,
                    buylink: shopNow.d3c,
                    variantId: variantList.d3c,
                },
            ],
        },
    ]);

    useEffect(() => {
        const variantIds = Object.values(variantList);
        getShopifyProductList(locale, variantIds).then((res) => {
            // 混入img productTitle price等参数
            const newD3sList = d3sList.map((d3s) => {
                return {
                    ...d3s,
                    productlist: d3s.productlist.map((item) => {
                        const target = res.find((resItem: any) => resItem.variantId === item.variantId);
                        return {
                            ...item,
                            price: target?.price,
                            compareAtPrice: target?.compareAtPrice,
                        };
                    }),
                };
            });
            setD3sList(newD3sList);
        });
    }, []);

    return (
        <>
            <ProductNav activeTab="Product" />
            <BannerAnimation />
            <Covered />
            {d3sList.map((item, index) => (
                <D3Serues key={index} id={item.id} title={item.title} desc={item.desc} imglist={item.imglist} productlist={item.productlist} />
            ))}
            <Certificate />
            <BlogNews />
            <FooterTcA />
        </>
    );
}
